"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles = react_native_1.StyleSheet.create({
    currentStage: {
        backgroundColor: colors_1.default.BLUE,
        color: colors_1.default.WHITE,
    },
    previousStage: {
        backgroundColor: colors_1.default.WHITE,
        borderColor: colors_1.default.BLUE,
        borderWidth: 1,
        color: colors_1.default.BLUE,
    },
    nextStage: {
        backgroundColor: colors_1.default.WHITE,
        borderColor: colors_1.default.BORDER_COLOR,
        borderWidth: 1,
        color: colors_1.default.GRAY_3,
    },
    lineBlueStyle: {
        borderWidth: 0.5,
        borderColor: colors_1.default.BLUE,
        margin: 10,
    },
    lineGrayStyle: {
        borderWidth: 0.5,
        borderColor: colors_1.default.BORDER_COLOR,
        margin: 10,
    },
    historyFilterCardStyle: {
        borderColor: colors_1.default.BORDER_COLOR,
        borderWidth: 1,
        borderRadius: 8,
        backgroundColor: colors_1.default.WHITE,
        margin: 5,
        padding: 20,
        minWidth: 250,
    },
    tableHeight: {
        height: 500,
    },
});
exports.default = styles;
